"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var react_1 = tslib_1.__importDefault(require("react"));
var react_2 = require("@jsonforms/react");
var CategorizationList_1 = require("./CategorizationList");
var SingleCategory_1 = require("./SingleCategory");
var tester_1 = require("./tester");
var util_1 = require("../../util");
var CategorizationRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(CategorizationRenderer, _super);
    function CategorizationRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onCategorySelected = function (category) { return function () {
            return _this.setState({ selectedCategory: category });
        }; };
        return _this;
    }
    /**
     * @inheritDoc
     */
    CategorizationRenderer.prototype.render = function () {
        var _a = this.props, uischema = _a.uischema, visible = _a.visible, getStyleAsClassName = _a.getStyleAsClassName;
        var categorization = uischema;
        var classNames = getStyleAsClassName('categorization');
        var masterClassNames = getStyleAsClassName('categorization.master');
        var detailClassNames = getStyleAsClassName('categorization.detail');
        var selectedCategory = this.findCategory(categorization);
        var subcategoriesClassName = getStyleAsClassName('category.subcategories');
        var groupClassName = getStyleAsClassName('category.group');
        return (react_1.default.createElement("div", { className: classNames, hidden: visible === null || visible === undefined ? false : !visible },
            react_1.default.createElement("div", { className: masterClassNames },
                react_1.default.createElement(CategorizationList_1.CategorizationList, { categorization: categorization, selectedCategory: selectedCategory, depth: 0, onSelect: this.onCategorySelected, subcategoriesClassName: subcategoriesClassName, groupClassName: groupClassName })),
            react_1.default.createElement("div", { className: detailClassNames },
                react_1.default.createElement(SingleCategory_1.SingleCategory, { category: selectedCategory, schema: this.props.schema, path: this.props.path }))));
    };
    CategorizationRenderer.prototype.findCategory = function (categorization) {
        var category = categorization.elements[0];
        if (this.state && this.state.selectedCategory) {
            return this.state.selectedCategory;
        }
        if (tester_1.isCategorization(category)) {
            return this.findCategory(category);
        }
        return category;
    };
    return CategorizationRenderer;
}(react_2.RendererComponent));
exports.default = util_1.withVanillaControlProps(react_2.withJsonFormsLayoutProps(CategorizationRenderer));
//# sourceMappingURL=CategorizationRenderer.js.map